export type HapticKind = 'light' | 'medium' | 'success' | 'warning'

const PATTERN: Record<HapticKind, number | number[]> = {
  light: 10,
  medium: 20,
  success: [12, 60, 24],
  warning: [30, 50, 30],
}

// navigator.vibrate only exists on Android Chrome/PWA; iOS Safari and desktop no-op.
export function haptic(kind: HapticKind = 'light') {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return
  try {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return
    navigator.vibrate(PATTERN[kind])
  } catch {}
}
